module.exports = __webpack_public_path__ + "img/[微笑].c5d51e12.svg";